import React from 'react';
import { Row, PillButton } from 'library/ui';
import { CalendarTodayOutlined, Add, CreditCardOutlined } from '@mui/icons-material';
import { useModalsContext } from 'ModalsContext';

export function ActionButtonRow({
    canPostJobs,
    canManagePayments,
    paymentSetupNeeded,
}: {
    canPostJobs: boolean;
    canManagePayments: boolean;
    paymentSetupNeeded: boolean;
}) {
    const { openJobForm } = useModalsContext();
    return (
        <Row gap="sm" wrap>
            {canPostJobs && (
                <PillButton icon={<Add sx={{ fontSize: 18 }} />} onClick={() => openJobForm('Business Dashboard')}>
                    Post a Job
                </PillButton>
            )}
            {canManagePayments && paymentSetupNeeded && (
                <PillButton variant="secondary" icon={<CreditCardOutlined sx={{ fontSize: 18 }} />} to="/payments">
                    Setup Payment
                </PillButton>
            )}
            <PillButton variant="secondary" icon={<CalendarTodayOutlined sx={{ fontSize: 18 }} />} to="/jobs">
                View My Jobs
            </PillButton>
        </Row>
    );
}
